import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository"
import EzUtils from "../../utils/EzUtils";

const resource = "/product";
export default {

  getProductCategoriesForOffice(officeId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/office/${officeId}/categories`);
  },

  getBrandsForOfficeAndCategory(officeId, category) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/${category}/brands?officeId=${officeId}`);
  },

  getModelsWithDetails(loanId, officeId, category, brand) {
    creditEngineRepository.setContentType("application/json");
    let params = "";
    if (EzUtils.isValidId(loanId)) {
      params = `${params}&loanId=${loanId}`;
    }
    if (EzUtils.isValidId(officeId)) {
      params = `${params}&officeId=${officeId}`;
    }
    if (category) {
      params = `${params}&category=${category}`;
    }
    if (brand) {
      params = `${params}&brand=${brand}`;
    }

    if (params) {
      params = `?${params.substring(1)}`;
    }
    return CreditEngineRepository.get(`${resource}/category/brand/modelsWithDetails${params}`);
  },

  validateProduct(validateProductRequestDto) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/validate`, validateProductRequestDto);
  }
}
